import React from "react";
import { getStaffAuditAccuracyQuality } from "../helpers/staff-audit-log-presentation-helper";


const StaffAuditAccuracyField = ({ accuracy }) => {
    const quality = getStaffAuditAccuracyQuality(accuracy);

    if (quality === "unknown")
    {
        return <span className="staff-audit-accuracy staff-audit-accuracy--unknown">—</span>;
    }

    return (
        <span
            className={ `staff-audit-accuracy staff-audit-accuracy--${ quality }` }
            title={ `${ accuracy } m` }>
            { Number(accuracy.toFixed(2)) } m
        </span>
    );
};

export default StaffAuditAccuracyField;
